import { PaymentAdditionalInfo } from '@nano/payment-additional-info';

export type ScheduledPaymentAction = 'EDIT' | 'REACTIVATE' | 'DUPLICATE' | 'CANCEL' | 'DELETE' | 'PUT_ON_HOLD';

export type ScheduledPaymentStatus = 'INITIATED' | 'CREATED' | 'CANCELED' | 'REMOVED' | 'TERM_ENDED' | 'ON_HOLD';

export enum ScheduledPaymentPeriodType {
  DO_NOT_REPEAT = 'DO_NOT_REPEAT',
  DAILY = 'DAILY',
  WEEKLY = 'WEEKLY',
  MONTHLY = 'MONTHLY',
  QUARTERLY = 'QUARTERLY',
  HALF_YEARLY = 'HALF_YEARLY',
  YEARLY = 'YEARLY'
}

export interface ScheduledPayment extends PaymentAdditionalInfo {
  actions: ScheduledPaymentAction[];
  allowedActions: ScheduledPaymentAction[];
  amount: number;
  beneficiaryAccountNumber: string;
  beneficiaryName: string;
  beneficiaryBankIdentifier?: string;
  beneficiaryBankName?: string;
  beneficiaryBankAddress?: string;
  beneficiaryBankFromClassifiers?: boolean;
  currency: string;
  fromDate: string;
  id: string;
  payerName: string;
  payerAccountNumber: string;
  paymentDetails: string;
  paymentCode: string;
  periodType: ScheduledPaymentPeriodType;
  status: ScheduledPaymentStatus;
  tillDate: string;
}

export const SCHEDULED_PAYMENT_LIST_STATUSES: ScheduledPaymentStatus[] = ['CREATED', 'CANCELED', 'TERM_ENDED', 'ON_HOLD'];

export interface ScheduledPaymentListFilters {
  query?: string;
}
